<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-question-pool`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 12a1 1 0 011 1v27h26.99a1 1 0 011 1v2a1 1 0 01-1 1H8a2 2 0 01-2-2V13a1 1 0 011-1h2zm23.741-9a2 2 0 011.437.608l6.258 6.46A2 2 0 0141 11.46v23.651A1.878 1.878 0 0139.133 37H14.867A1.878 1.878 0 0113 35.111V4.89C13 3.846 13.836 3 14.867 3H32.74zm-.851 4H17v26h20V12.324L31.89 7zM28 23a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6zm4-8a1 1 0 011 1v2a1 1 0 01-1 1H22a1 1 0 01-1-1v-2a1 1 0 011-1h10z"/></svg>
</template>
<script>

export default {
  name: 'IconQuestionPool',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
